export default "__VITE_ASSET__dIuDUmtJ__"